import {PageContainer} from '../../components/Pages'
import { Box, Button, Link } from '@mui/material'
import hiringbanner from '../../assets/images/job/intern job poster mak.png'
import { useEffect } from 'react';

export default function Home() {

    useEffect(() => {
        document.title = "Careers | iverto.ai"; 
        document.description = "Apply now for Full Stack App Developer Intern and AI Intern positions"
      }, []);

    return (
        <PageContainer
            sx={{
                marginTop: '100px',
            }}
        >
            <Box
                sx={{
                    maxWidth: '90%',
                    maxHeight: '80vh',
                    objectFit: 'cover',
                    borderRadius:'20px',
                }}
                component={'img'}
                src={hiringbanner}
                alt="hiring"
                loading="lazy"
            >
            </Box>
            <Link
                href='https://forms.gle/bqV8Nj3Qr5jpkoEz9'
                target="_blank"
                rel="noreferrer"
                sx={{
                    '&:hover':{
                    textDecoration: 'none',
                    color: 'primary.dark',
                    },
                    display: 'flex',
                    gap:1,
                    justifyContent:'center',
                }}
            >

                <Button
                variant="contained"
                color="primary"
                sx={{ 
                    mt: 2 
                }}
                >
                    Apply Now
                </Button>
            </Link>
        </PageContainer>
    );
}